__turbopack_context__.v({
  "customRow": "z6oDia_customRow",
  "row": "z6oDia_row",
  "rowLabel": "z6oDia_rowLabel",
  "rows": "z6oDia_rows",
  "section": "z6oDia_section",
  "sectionTitle": "z6oDia_sectionTitle",
});
